<div class="impersonation-bar">
    <span class="impersonation-bar__info">
        <span class="material-icons">visibility</span>
        {{ 'impersonation.active' | translate }}
    </span>
    <div class="impersonation-bar__actions">
        <button
            class="btn btn-secondary impersonation-bar__settings"
            (click)="goToSettings()"
            [matTooltip]="'impersonation.settings' | translate"
            matTooltipPosition="below"
        >
            <span class="material-icons">settings</span>
        </button>
        <button
            class="btn btn-secondary impersonation-bar__end"
            (click)="endImpersonation()"
            [matTooltip]="'impersonation.end' | translate"
            matTooltipPosition="below"
        >
            <span class="material-icons">close</span>
        </button>
    </div>
</div>
